<template>
  <header class="registration-header">
    <div class="registration-header__inner">
      <LogoLink />
      <div class="registration-header__login-button">
        <BaseGhostButtonLink
          href="/signin/"
          target="_blank"
          class="--s"
        >
          войти в мтс линк
        </BaseGhostButtonLink>
      </div>
    </div>
  </header>
</template>

<script>
import BaseGhostButtonLink from '@/components/NewDesign/Common/Base/BaseGhostButtonLink.vue'
import LogoLink from '@/components/NewDesign/Common/UI/LogoLink.vue'

export default {
  name: 'RegistrationHeader',
  components: { LogoLink, BaseGhostButtonLink },
}
</script>

<style lang="scss" scoped>
.registration-header {
  @include screen-up('lg') {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 100;
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 32px;

    @include screen-down('lg') {
      justify-content: center;
    }
  }

  &__login-button {
    @include screen-down('lg') {
      display: none;
    }
  }
}
</style>
